import { Component, OnDestroy } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { tap } from 'rxjs/operators'
import { Store } from '@ngrx/store'
import { C4PaymentMethodDetail } from '@api/http.service'
import { selectProfileState } from '../user-profile/user-profile.state'
import { Subscriptions } from '../../utils/subscriptions'
import { PendingState } from '../account.root.state'
import { Observable } from 'rxjs'
import { environment } from '@environment/environment'

@Component({
  selector: 'cover-user-payment-methods',
  templateUrl: './user-payment-methods.component.html',
  styleUrls: ['./user-payment-methods.component.scss'],
})
export class UserPaymentMethodsComponent implements OnDestroy {
  // selectedIndex: number = 0

  maxPaymentMethodsAllowed: number | null = environment.maxPaymentMethodsAllowed
  paymentMethods: C4PaymentMethodDetail[] = []
  pending$: Observable<PendingState>
  readonly pendingState = PendingState

  private readonly subscriptions: Subscriptions = new Subscriptions(true)

  c4SessionId: string = ''
  adrNr: number | undefined
  adrGr: string = ''
  personNr: number = 0
  constructor(private readonly dialog: MatDialog, private readonly store: Store) {
    this.pending$ = store.select(selectProfileState.paymentMethodsPendingState)

    this.subscriptions.plusOne = store
      .select(selectProfileState.customerSubNr)
      .pipe(
        tap(customerSubNr => {
          if (customerSubNr !== '') {
            this.personNr = customerSubNr as unknown as number
          }
        }),
      )
      .subscribe()

    this.subscriptions.plusOne = store
      .select(selectProfileState.adrGr)
      .pipe(
        tap(adrGr => {
          this.adrGr = adrGr
        }),
      )
      .subscribe()
    this.subscriptions.plusOne = store
      .select(selectProfileState.c4SessionId)
      .pipe(
        tap(sessionId => {
          this.c4SessionId = sessionId
        }),
      )
      .subscribe()
    // this.subscriptions.plusOne = store
    //   .select(selectProfileState.customerInformationState)
    //   .pipe(
    //     tap(address => {
    //       this.adrNr = address.customerNumber as unknown as number
    //       this.checkPaymentMethods()
    //     }),
    //   )
    //   .subscribe()

    this.subscriptions.plusOne = store
      .select(selectProfileState.paymentMethodsState)
      .pipe(
        tap(paymentMethods => {
          this.paymentMethods = paymentMethods
        }),
      )
      .subscribe()
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  // checkPaymentMethods(): void {
  //   if (this.c4SessionId && this.adrNr && this.adrGr && this.personNr !== undefined) {
  //     this.store.dispatch(
  //       CustomerInfoActions.paymentMethodsLoad({
  //         payload: {
  //           sessionId: this.c4SessionId,
  //           adrNr: this.adrNr,
  //           adrGr: this.adrGr,
  //           personNr: this.personNr,
  //         },
  //       }),
  //     )
  //   }
  // }

  // deletePaymentMethod(index: number): void {
  // let openedDialog = this.dialog.open(DeletePaymentMethodComponent)
  // let subscription = openedDialog
  //   .afterClosed()
  //   .pipe(
  //     tap(dialogReturnValue => {
  //       if (dialogReturnValue === 'true') {
  //         this.paymentMethods.splice(index, 1)
  //         subscription.unsubscribe()
  //       }
  //     }),
  //   )
  //   .subscribe()
  // }

  // changeDefaultPaymentMethod(index: number): void {
  //   this.selectedIndex = index
  // }
}
